"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Docs;

var _react = _interopRequireDefault(require("react"));

var _SvgIconWrap = _interopRequireDefault(require("../../../components/SvgIcon/SvgIconWrap"));

function Docs(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIconWrap.default, props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.3266667,2 L15.3266667,6.45111111 L19.7777778,6.45111111 L19.7777778,22 L4.22222222,22 L4.22222222,2 L15.3266667,2 Z M16,15 L7,15 L7,17 L16,17 L16,15 Z M16,11 L7,11 L7,13 L16,13 L16,11 Z M16.2555556,2 L19.7777778,5.52222222 L19.7777778,5.65777778 L16.0740741,5.65777778 L16.0740741,2 L16.2555556,2 Z"
  }));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/Upload/icons/Docs.js
// module id = 2003
// module chunks = 6 7 17 18